import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const linkOrderPackage = createAction(ACTION.LINK_ORDER_PACKAGE.REQUEST, (packageCode, orderCode, payload = {}) => ({...payload, packageCode, orderCode}));
export const clearState = createAction(ACTION.CLEAR_STATE, packageCode => ({packageCode}));
